import {
  TargetResourceModel,
  TargetResourceGetAttributes,
  TargetResourceCollection,
} from 'src/models/TargetResourceModel';
import {
  TargetResourceAdapterInteface,
  ListTargetResourcesInput as BaseListTargetResourcesInput,
} from 'src/adapter/TargetResourceAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListTargetResourcesInput = BaseListTargetResourcesInput;
export class TargetResourceApiClass {
  adapter: TargetResourceAdapterInteface;
  constructor(adapter: TargetResourceAdapterInteface) {
    this.adapter = adapter;
  }
  async listTargetResources(
    enquete_id: string,
    conditions?: ListTargetResourcesInput
  ): Promise<{ total: number; data: TargetResourceCollection }> {
    try {
      const res = await this.adapter.listTargetResources(
        enquete_id,
        conditions
      );
      return {
        total: res.total,
        data: res.data.map(
          (TargetResource: TargetResourceGetAttributes) =>
            new TargetResourceModel(TargetResource)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getTargetResource(
    enquete_id: string,
    id: string
  ): Promise<TargetResourceModel> {
    try {
      const TargetResource = await this.adapter.getTargetResource(
        enquete_id,
        id
      );
      return new TargetResourceModel(TargetResource);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
